const PRIMARY_COLOR = "#0095DA";
const SECONDARY_COLOR = "#E1F0FF";
const BG_COLOR = "#FFFFFF"

const lightTheme = {
  primaryColor: PRIMARY_COLOR,
  secondaryColor: SECONDARY_COLOR,
  backgroundColor: BG_COLOR,
  appbarColor: `#0095DA`,
  navbarColor: `#0095DA`,
  buttonColor: `#0095DA`,
  buttonHoverColor: `#0095DA`,
};

export default lightTheme;
